import KsbAlert from "../../../2_ksbHub/components/KsbAlert";

function SondertageAlerts({
  showUnlockedToast,
  setShowUnlockedToast,
  errorMessage,
  setErrorMessage,
}) {
  return (
    <>
      <KsbAlert
        open={showUnlockedToast}
        onClose={() => setShowUnlockedToast(false)}
        message="Reservierung ist jetzt geöffnet!"
      />

      <KsbAlert
        open={!!errorMessage}
        onClose={() => setErrorMessage("")}
        message={errorMessage}
        severity="error"
      />
    </>
  );
}

export default SondertageAlerts;
